/*
设备完好率--按日呈现
 */
import React, { Component } from "react";
import Echarts from "echarts";
import moment from "moment";
import { getRateDay } from "../../../fetch/fetchApi";
import fetchHandler from "../../../fetch/fetchHandler";

class StubDay extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = {
      noData: false,
      year: moment(new Date()).format("YYYY.MM"),
      cityId: this.props.param.cityId,
      operationProperty: this.props.param.operationProperty,
      operationMode: this.props.param.operationMode,
      type: this.props.param.type,
      time: moment(this.props.param.date).format("YYYY-MM"),
    };
    this.layout = [
      "inline", // 横向布局
      "vertical", // 弹窗布局
      "horizontal", // 纵向布局
    ];
  }

  // 秒转换
  handleSecord(value) {
    const day = Math.floor(value / (24 * 3600)); // Math.floor()向下取整
    const hour = Math.floor((value - day * 24 * 3600) / 3600);
    const minute = Math.floor((value - day * 24 * 3600 - hour * 3600) / 60);
    const second = value - day * 24 * 3600 - hour * 3600 - minute * 60;
    if (day > 0) {
      return `${day}天${hour}时${minute}分`; // + second + "秒";
    } else if (hour > 0) {
      return `${hour}时${minute}分`; // + second + "秒";
    } else if (minute > 0) {
      return `${minute}分`; // + second + "秒";
    } else {
      return `${second}秒`;
    }
  }

  /**
   * 页面加载后执行，调用接口获取数据，渲染图表
   */
  componentDidMount() {
    this.init();
  }

  componentWillMount() {}

  /**
   * 父组件传递参数修改时执行
   */
  componentWillReceiveProps(nextProps) {
    /**
     * flag ：判断选择月份是否改变
     * time ：设置选择日期的月份
     */
    const flag = moment(
      nextProps.param.date.length === 10 ? nextProps.param.date : `${nextProps.param.date}-01`,
    ).format("YYYY-MM")
      === moment(
        this.props.param.date.length === 10 ? this.props.param.date : `${this.props.param.date}-01`,
      ).format("YYYY-MM");
    const time = moment(
      nextProps.param.date.length === 10 ? nextProps.param.date : `${nextProps.param.date}-01`,
    ).format("YYYY-MM");

    /**
     * 判断调用接口所需的参数是否改变
     */
    if (
      nextProps.param.cityId === this.props.param.cityId
      && nextProps.param.operationProperty === this.props.param.operationProperty
      && nextProps.param.operationMode === this.props.param.operationMode
      && nextProps.param.type === this.props.param.type
      && flag
    ) {
      // 若改变，退出后续方法

    } else {
      // 改变，设置参数，调用接口获取数据，渲染图表
      this.setState(
        {
          year: moment(nextProps.param.date).format("YYYY.MM"),
          cityId: nextProps.param.cityId,
          operationProperty: nextProps.param.operationProperty,
          operationMode: nextProps.param.operationMode,
          type: nextProps.param.type,
          time: time,
        },
        () => {
          this.queryStubOperationModeInfo();
        },
      );
    }
  }

  init() {
    this.queryStubOperationModeInfo();
  }

  // 调用接口获取数据
  queryStubOperationModeInfo() {
    fetchHandler(getRateDay, {
      cityId: this.state.cityId,
      operationProperty: this.state.operationProperty,
      type: this.state.type,
      time: this.state.time,
      operationMode: this.state.operationMode,
    }).then((res) => {
      // 设置数据
      this.setState(
        {
          stubData: res.data,
        },
        () => {
          // 渲染图表方法
          this.stubIntactChart();
        },
      );
    });
  }

  /**
   * 完好率按日期图表展示
   */
  stubIntactChart() {
    const dataArry = [...this.state.stubData];
    // 设置 x轴
    const xAxisData = dataArry.map((item) => {
      return moment(item.date).format("MM.DD");
    });
    // 设置平均完好时长数据
    const intactData = dataArry.map((item) => {
      const foo = {
        value: item.intactRate,
        info: {
          value: this.handleSecord(
            parseInt(
              (item.totalOperationDuration - item.totalErrorDuration - item.totalOfflineDuration)
                / item.stubCnt,
            ),
          ),
          name: "平均完好时长",
        },
      };
      return foo;
    });

    // 设置平均离线时长数据
    const offlineData = dataArry.map((item) => {
      const foo = {
        value: item.offlineRate,
        info: {
          value: this.handleSecord(parseInt(item.totalOfflineDuration / item.stubCnt)),
          name: "平均离线时长",
        },
      };
      return foo;
    });

    // 设置故障时长数据
    const errorData = dataArry.map((item) => {
      const foo = {
        value: item.errorRate,
        info: {
          value: this.handleSecord(parseInt(item.totalErrorDuration / item.stubCnt)),
          name: "平均故障时长",
        },
      };
      return foo;
    });
    // 设置可用时长数据
    const availableRateData = dataArry.map((item) => {
      const foo = {
        value: item.availableRate,
        info: {
          value: this.handleSecord(parseInt(item.totalAvailableDuration / item.availableCnt)),
          name: "平均可用时长",
        },
      };
      return foo;
    });

    // 设置设备总数
    const stubNumData = dataArry.map((item) => {
      return item.stubCnt === null ? 1 : item.stubCnt;
    });
    // 设置可用设备总数
    const availableCntData = dataArry.map((item) => {
      return item.availableCnt === null ? 1 : item.availableCnt;
    });

    // 设置 设备总数y轴最大值
    const maxY1 = parseInt(Math.max(...availableCntData) / 10) * 10;

    const myChart = Echarts.init(document.getElementById("chart2IntactDay"));
    const option = {
      color: ["#e5323e", "#0000CD", "#6B8E23", "#FFD700", "#5B8FF9", "#5AD8A6"],
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "cross",
          crossStyle: {
            color: "#999",
          },
        },
        formatter: (param) => {
          let toolInfo = "";

          const names = param.map((v) => v.seriesName);
          const index1 = names.findIndex((v) => v === "可用设备总数");
          const index2 = names.findIndex((v) => v === "完好设备总数");
          const includesName1 = names.includes("可用设备总数");
          const includesName2 = names.includes("完好设备总数");

          if (includesName1 && !includesName2) {
            toolInfo = `可用设备总数: ${param[index1].value}`;
          } else if (includesName2 && !includesName1) {
            toolInfo = `完好设备总数: ${param[index2].value}`;
          } else if (includesName1 && includesName2) {
            toolInfo = `可用设备总数:${param[index1].value},完好设备总数:${param[index2].value}`;
          }

          param.map((item) => {
            if (item.seriesName !== "可用设备总数" && item.seriesName !== "完好设备总数") {
              const msg = `
                                       <div> ${item.data.info.name}:${item.data.info.value}, ${item.seriesName}:${item.value}%</div>
                                      `;
              toolInfo += msg;
            }
            return true;
          });
          return toolInfo;
        },
      },
      legend: {
        data: [
          "完好率",
          "离线率",
          "故障率",
          "可用率",
          {
            name: "可用设备总数",
            icon: "circle",
          },
          {
            name: "完好设备总数",
            icon: "circle",
          },
        ],
      },
      grid: {
        left: "50px",
        right: "70px",
      },
      xAxis: [
        {
          type: "category",
          data: xAxisData,
          axisLabel: {
            interval: 0,
            rotate: xAxisData.length > 10 ? 35 : 0,
            margin: 10,
            textStyle: {
              fontWeight: "bolder",
              color: "#000000",
            },
          },
        },
      ],
      yAxis: [
        {
          type: "value",
          name: "",
          min: 0,
          max: 100,
          interval: 10,
          axisLabel: {
            formatter: "{value} %",
          },
        },
        {
          type: "value",
          name: "设备数量",
          interval: Math.ceil(maxY1 / 10),
          min: 0,
          max: maxY1,
          axisLabel: {
            formatter: "{value}",
          },
        },
      ],
      series: [
        {
          name: "完好率",
          type: "line",
          yAxisIndex: 0,
          data: intactData,
        },
        {
          name: "离线率",
          type: "line",
          yAxisIndex: 0,
          data: offlineData,
        },
        {
          name: "故障率",
          type: "line",
          yAxisIndex: 0,
          data: errorData,
        },
        {
          name: "可用率",
          type: "line",
          yAxisIndex: 0,
          data: availableRateData,
        },
        {
          name: "可用设备总数",
          type: "bar",
          // barWidth:20,
          yAxisIndex: 1,
          barGap: 0,
          data: availableCntData,
        },
        {
          name: "完好设备总数",
          type: "bar",
          // barWidth:20,
          yAxisIndex: 1,
          barGap: 0,
          data: stubNumData,
        },
      ],
      contentToOption: function () {
        // 数据视图刷新的方法
      },
    };
    myChart.clear();
    myChart.setOption(option);
    // 图例选中状态事件
    myChart.on("legendselectchanged", () => {});

    // 点击设备总数列，选择日期
    myChart.on("click", (obj) => {
      const xLine = this.state.stubData.map((item) => {
        return moment(item.date).format("MM.DD");
      });
      this.props.changeDay(`${this.state.year}.${xLine[obj.dataIndex].split(".")[1]}`);
    });
  }

  render() {
    return (
      <div className='analysis-content-3'>
        <div style={{ width: "100%", height: 400, overflowY: "auto" }} id='chart2IntactDay'></div>
      </div>
    );
  }
}

export default StubDay;



// WEBPACK FOOTER //
// ./src/AntD/pages/indicatorReport/stubIntactRate/stubDay.js